import { Capacitor } from '@capacitor/core'
import { LocalNotifications } from '@capacitor/local-notifications'

const DAILY_NOTIFICATION_ID = 1001
const DAILY_NOTIFICATION_KEY = 'dailyNotificationTime'

type StoredDailyTime = {
  dateKey: string
  hour: number
  minute: number
}

function getTodayKey(now: Date): string {
  return now.toISOString().slice(0, 10)
}

function loadStoredTime(): StoredDailyTime | undefined {
  try {
    const raw = localStorage.getItem(DAILY_NOTIFICATION_KEY)
    if (!raw) return undefined
    return JSON.parse(raw) as StoredDailyTime
  } catch {
    return undefined
  }
}

function storeTime(time: StoredDailyTime): void {
  localStorage.setItem(DAILY_NOTIFICATION_KEY, JSON.stringify(time))
}

export async function scheduleDailyListNotification(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return

  const perm = await LocalNotifications.requestPermissions()
  if (perm.display !== 'granted') return

  const now = new Date()
  const todayKey = getTodayKey(now)

  const stored = loadStoredTime()
  const baseTime =
    stored && stored.dateKey === todayKey
      ? stored
      : { dateKey: todayKey, hour: now.getHours(), minute: now.getMinutes() }

  if (!stored || stored.dateKey !== todayKey) {
    storeTime(baseTime)
  }

  const next = new Date(now)
  next.setDate(now.getDate() + 1)
  next.setHours(baseTime.hour, baseTime.minute, 0, 0)

  await LocalNotifications.schedule({
    notifications: [
      {
        id: DAILY_NOTIFICATION_ID,
        title: 'New Daily Trivia Challenge',
        body: 'A fresh challenge is ready! Play now and see how you rank.',
        schedule: { at: next },
      },
    ],
  })
}
